/**
 * Hook pour acceder aux donnees de la company active
 *
 * Les donnees sont lues synchroniquement depuis le session store,
 * garanti READY par SessionProvider.
 *
 * @module useActiveCompany
 * @author Equipe Brydge
 * @since 3.0.0
 */

import {useMemo} from 'react';
import useSessionStore from 'packages/common/stores/sessionStore';

export const useActiveCompany = () => {
  const activeCompany = useSessionStore((s) => s.activeCompany);
  const companies = useSessionStore((s) => s.companies);

  return useMemo(() => ({
    companyId: activeCompany?._id || null,
    company: activeCompany,
    timezone: activeCompany?.timezone || null,
    name: activeCompany?.name || null,
    slug: activeCompany?.slug || null,
    logoPath: activeCompany?.logoPath || null,
    hasStripeAccount: activeCompany?.hasStripeAccount || false,
    activitySectors: activeCompany?.activitySectors || [],
    primaryColor: activeCompany?.primaryColor || null,
    publicApiKey: activeCompany?.publicApiKey || null,
    companies,
    hasMultipleCompanies: (companies || []).length > 1,
    totalCompanies: (companies || []).length,
  }), [activeCompany, companies]);
};
